var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "map-featured", attrs: { id: "map-featured" } },
    [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "close",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("i", { staticClass: "icon icon-cross" })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }